module.exports = __webpack_public_path__ + "static/img/2023.11.718198a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/companyprofilepic/2023.11.jpg
// module id = qzoL
// module chunks = 51